interface TrackingParams {
  // eslint-disable-next-line camelcase
  trk_location?: string;
  // eslint-disable-next-line camelcase
  trk_vertical?: string;
  // eslint-disable-next-line camelcase
  trk_format?: string;
}

interface SegmentTrackingAttributes {
  driverPageName: string;
  driverLocation: string;
  driverSubLocation?: string;
  deployableName: string;
  deployableVersion: string;
}

interface OpenAuthDialogParams {
  authType?: 'signin' | 'register';
  trk?: TrackingParams;
  regTrackingAttributes?: {
    entityNames?: Record<string, unknown>;
    cohort?: string;
  };
  segmentTrackingAttributes?: SegmentTrackingAttributes;
  onSuccessActions?: string | ((identity?: any) => void);
  onCleanUp?: (identity?: any) => void;
  variantName?: string;
}

export const openAuthDialog = (params: OpenAuthDialogParams): void => {
  const {
    authType,
    trk,
    regTrackingAttributes,
    segmentTrackingAttributes,
    onSuccessActions,
    onCleanUp,
    variantName,
  } = params;

  window?.nwapi?.ui?.showAuthDialog({
    authType,
    version: 2,
    trk,
    regTrackingAttributes,
    segmentTrackingAttributes,
    onSuccess: onSuccessActions,
    onCleanUp,
    abTest: {
      variantName,
    },
  });
};
